import type { ReactNode } from 'react';
import { useFela } from 'react-fela';
import { Link, type LinkProps } from 'react-router-dom';

import { SettingsItem } from '@/modules/forms';
import { Icon, Text } from '@/modules/ui';

import * as felaRules from './SettingsLink.rules';

export interface SettingsLinkProps {
    to: LinkProps['to'];
    title: string;
    /** Rendered next to the title. Must not be interactive — the row itself already is. */
    trailing?: ReactNode;
    /** When given, the row runs this instead of navigating to `to`. */
    onClick?: () => void;
}

export const SettingsLink = ({ to, title, trailing, onClick }: SettingsLinkProps) => {
    const { css } = useFela();

    const content = (
        <Text elementType='span' variant='ParagraphSmallMedium' customStyle={felaRules.link}>
            <span className={css(felaRules.label)}>
                {title}
                {trailing}
            </span>
            <Icon type='dropdown' width={20} height={20} customStyle={felaRules.anchor} />
        </Text>
    );

    return (
        <SettingsItem>
            {onClick ? (
                <button type='button' className={css(felaRules.button)} onClick={onClick}>
                    {content}
                </button>
            ) : (
                <Link to={to}>{content}</Link>
            )}
        </SettingsItem>
    );
};
